export function queryShadowElement (
    selector: string,
    fallbackElement: HTMLElement,
    maxRootsToVisit = 10000,
): HTMLElement {
    const rootDocument = globalThis.document;
    if (!rootDocument || typeof selector !== 'string' || !selector.trim()) {
        return fallbackElement;
    }

    const visitedRoots = new Set<Document | ShadowRoot>();
    const rootsToVisit: Array<Document | ShadowRoot> = [rootDocument];

    while (rootsToVisit.length > 0) {
        if (visitedRoots.size >= maxRootsToVisit) {
            return fallbackElement;
        }

        const root = rootsToVisit.pop();
        if (!root || visitedRoots.has(root)) {
            continue;
        }
        visitedRoots.add(root);

        try {
            const directMatch = root.querySelector(selector);
            if (directMatch instanceof HTMLElement) {
                return directMatch;
            }
        } catch {
            return fallbackElement;
        }

        let elements: Element[];
        try {
            elements = Array.from(root.querySelectorAll('*'));
        } catch {
            continue;
        }

        for (const element of elements) {
            try {
                const shadowRoot = element.shadowRoot;
                if (shadowRoot && !visitedRoots.has(shadowRoot)) {
                    rootsToVisit.push(shadowRoot);
                }
            } catch {
                continue;
            }
        }
    }

    return fallbackElement;
}
